/**
 * In-memory access token store for the SPA. The refresh token lives in an
 * httpOnly `.chotca.com` cookie set by the backend; the SPA never touches it.
 * Access token returned by /auth/refresh is held here and attached as a
 * Bearer header by the SDK on each request.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
